"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _get = _interopRequireDefault(require("lodash/get"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonCta = require("@mmc/common-cta");

var _commonRichText = require("@mmc/common-rich-text");

var _reactRedux = require("react-redux");

var _clsx = _interopRequireDefault(require("clsx"));

var _actions = require("../actions");

var _ctaRow = require("./cta-row.propTypes");

var _ctaRow2 = _interopRequireDefault(require("./cta-row.css"));

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
    formatAsMKSPath = dataUtils.formatAsMKSPath;

var isMexicoMarket = function isMexicoMarket(market) {
  return String(market).toLowerCase() === 'mx';
};

var CtaRow = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CtaRow, _React$Component);

  CtaRow.resourceType = function resourceType() {
    return 'CTA_Row_1_0_0';
  };

  function CtaRow(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = CtaRow.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        market = _this$props.market,
        position = _this$props.position,
        dispatch = _this$props.dispatch,
        promos = _this$props.promos;

    if (promos.length && isMexicoMarket(market)) {
      var componentId = this.getComponentId(position);
      var claimedPromo = promos.find(function (promo) {
        return promo.ctaId === componentId;
      });
      var hasUnclaimedPromos = promos.find(function (promo) {
        return !promo.ctaId;
      });

      if (!claimedPromo && hasUnclaimedPromos) {
        dispatch((0, _actions.claimPromo)(componentId, position));
      }
    }
  };

  _proto.handleMouseDown = function handleMouseDown(e, linkUrl) {
    var _this$props2 = this.props,
        market = _this$props2.market,
        promos = _this$props2.promos,
        position = _this$props2.position,
        currentPath = _this$props2.currentPath;

    if (isMexicoMarket(market) && typeof window !== 'undefined' && window.dataLayer) {
      var componentId = this.getComponentId(position);
      var claimedPromo = promos.find(function (promo) {
        return promo.ctaId === componentId;
      });

      if (claimedPromo) {
        var locationId = claimedPromo.locationId,
            promotionId = claimedPromo.promotionId,
            promotionName = claimedPromo.promotionName,
            bannerPosition = claimedPromo.bannerPosition;

        if (typeof bannerPosition === 'number') {
          window.dataLayer.push({
            event: 'select_banner',
            promotiondata: [{
              position: 'Body',
              cta_name: e.currentTarget.innerText,
              content_url: e.currentTarget.href,
              banner_name: promotionName,
              banner_position: bannerPosition,
              banner_image_url: promotionId,
              layer: formatAsMKSPath(currentPath)
            }]
          });
        } else {
          window.dataLayer.push({
            event: 'select_promotion',
            promotiondata: [{
              position: 'Body',
              cta_name: e.currentTarget.innerText,
              content_url: e.currentTarget.href,
              location_id: locationId,
              promotion_id: promotionId,
              promotion_name: promotionName,
              layer: formatAsMKSPath(currentPath)
            }]
          });
        }
      }
    }

    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      if (['/concesionarios', '/localizador-concessionarios', '/loyda-lahin-jalleenmyyjasi'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'dealer_locator_click',
          comp_page: {
            position: 'page'
          }
        });
      }

      if (['/empresa/contacto', '/empresa/contactar', '/ota-yhteytta'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'contact_form_click',
          comp_page: {
            position: 'page'
          }
        });
      }

      if (linkUrl.includes('/prueba') || linkUrl.includes('/test-drive') || linkUrl.includes('/varaa-koeajo')) {
        var modelName = '';

        if (window.location && window.location.pathname && (window.location.pathname.includes('/mallisto') || window.location.pathname.includes('/modelos'))) {
          // eslint-disable-next-line prefer-destructuring
          modelName = window.location.pathname.split('/')[2];
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'test_drive_request_click',
          comp_product: {
            position: 'page',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: modelName.toLowerCase(),
            version: null,
            fuel_type: null,
            dealer_name: null
          }
        });
      }
    }
  };

  _proto.getComponentId = function getComponentId(position) {
    return CtaRow.resourceType() + "_" + position;
  };

  _proto.getCtaClassByPriority = function getCtaClassByPriority(priority) {
    var market = this.props.market;

    if (priority === 'low') {
      return _ctaRow2["default"].lowCta;
    }

    if (priority === 'lowIcon' && isMexicoMarket(market)) {
      return _ctaRow2["default"].lowIconCtaMx;
    }

    if (priority === 'lowIcon') {
      return _ctaRow2["default"].lowIconCta;
    }

    return _ctaRow2["default"].cta;
  };

  _proto.labelIsMissing = function labelIsMissing(data) {
    return handleNestedProp(data, 'data.label') === ' ' || handleNestedProp(data, 'data.label') === null || handleNestedProp(data, 'data.label') === '';
  };

  _proto.headlineIsMissing = function headlineIsMissing(data) {
    return handleNestedProp(data, 'data.headline') === ' ' || handleNestedProp(data, 'data.headline') === null || handleNestedProp(data, 'data.headline') === '';
  };

  _proto.descriptionIsMissing = function descriptionIsMissing(data) {
    return handleNestedProp(data, 'data.description') === ' ' || handleNestedProp(data, 'data.description') === null || handleNestedProp(data, 'data.description') === '';
  };

  _proto.spanToGrid = function spanToGrid(_span, _align) {
    var columnClass = 'col-sm-10';
    var columnOffset = 'col-sm-offset-1';

    switch (_span) {
      case 'span50':
        columnClass = 'col-sm-6';

        switch (_align) {
          case 'left':
            columnOffset = 'col-sm-offset-1';
            break;

          case 'center':
            columnOffset = 'col-sm-offset-3';
            break;

          case 'right':
            columnOffset = 'col-sm-offset-5';
            break;

          default:
            columnOffset = '';
        }

        break;

      case 'span75':
        columnClass = 'col-sm-8';

        switch (_align) {
          case 'left':
            columnOffset = 'col-sm-offset-1';
            break;

          case 'center':
            columnOffset = 'col-sm-offset-2';
            break;

          case 'right':
            columnOffset = 'col-sm-offset-3';
            break;

          default:
            columnOffset = '';
        }

        break;

      case 'span100':
        columnClass = 'col-sm-10';
        columnOffset = 'col-sm-offset-1';
        break;

      default:
        columnClass = 'col-sm-12';
        columnOffset = '';
    }

    return {
      column: columnClass,
      offset: columnOffset
    };
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        data = _this$props3.data,
        theme = _this$props3.theme,
        market = _this$props3.market,
        promos = _this$props3.promos,
        position = _this$props3.position;
    var CTAs = data.CTAs;
    var labelIsMissing = this.labelIsMissing(data);
    var headlineIsMissing = this.headlineIsMissing(data);
    var descriptionIsMissing = this.descriptionIsMissing(data);
    var hasPromo = isMexicoMarket(market) && promos.find(function (promo) {
      return promo.ctaId === CtaRow.resourceType() + "_" + position;
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid']
    }, labelIsMissing && headlineIsMissing && descriptionIsMissing ? '' : /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['col-xs-12'], theme[this.spanToGrid(data.textSpan, data.alignment).column], theme[this.spanToGrid(data.textSpan, data.alignment).offset], _ctaRow2["default"].ctaInfo, _ctaRow2["default"][handleNestedProp(data, 'data.alignment')])
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _ctaRow2["default"].blockDividerWrap
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _ctaRow2["default"].blockDivider
    })), labelIsMissing ? '' : /*#__PURE__*/_react["default"].createElement("h2", {
      className: (0, _clsx["default"])(theme.labelMedium, _ctaRow2["default"].label)
    }, handleNestedProp(data, 'data.label')), headlineIsMissing ? '' : /*#__PURE__*/_react["default"].createElement("h3", {
      className: (0, _clsx["default"])(theme.headingFive, theme.colorDarkGrey, theme.marginTop20)
    }, handleNestedProp(data, 'data.headline')), descriptionIsMissing ? '' : /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme.bodyCopy, theme.colorDarkGrey, theme.marginTop5, _ctaRow2["default"].richTextHeadlines)
    }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      format: null,
      html: handleNestedProp(data, 'data.description'),
      tagName: "p"
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme.row, _ctaRow2["default"].ctaOuterContainer)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-10'], theme['col-sm-offset-1'], _ctaRow2["default"].ctaContainer, _ctaRow2["default"]["alignment-" + data.alignment])
    }, CTAs && CTAs.map(function (cta, i) {
      return /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        key: i,
        theme: theme,
        mouseDownEvent: function mouseDownEvent(e) {
          return _this2.handleMouseDown(e, (0, _get["default"])(cta, 'url'));
        },
        data: {
          url: (0, _get["default"])(cta, 'url'),
          label: (0, _get["default"])(cta, 'label'),
          priority: (0, _get["default"])(cta, 'priority'),
          openNewTab: (0, _get["default"])(cta, 'openNewTab'),
          theme: (0, _get["default"])(cta, 'theme'),
          icon: (0, _get["default"])(cta, 'icon'),
          ctaType: (0, _get["default"])(cta, 'ctaType')
        },
        classes: ["" + (hasPromo ? "hasTrackedPromo-" + i : ''), "" + _this2.getCtaClassByPriority((0, _get["default"])(cta, 'priority'))]
      });
    }))));
  };

  return CtaRow;
}(_react["default"].Component);

CtaRow.displayName = 'CtaRow';

var mapStateToProps = function mapStateToProps(state) {
  return {
    promos: (0, _get["default"])(state, 'promos.promos') || [],
    market: state.Config.market
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(CtaRow);

exports["default"] = _default;